<template>
  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          <div class="header-title">
            Notifications
          </div>
        </template>
      </EsHeader>
    </div>
    <es-loader v-if="loading" style="margin: 5rem"/>
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
      margin="0"
      style="padding: 5rem"
    />
    <div v-else class="content">
      <div style="padding-bottom: 1rem">
        <div class="notification-type">
          <div>
            <th>
              <font-awesome-icon :icon="['fas', 'cog']" size="lg"/>
                System Notifications
            </th>
          </div>
          <div class="icon-right">
            <!--
            <a>
              <font-awesome-icon
                :icon="['fal', 'plus']"
                size="2x"
                title="Add System Notifications"
                role="button"
                tabindex="0"
                @click="addNewSystemNotifications()"
                @keypress="addNewSystemNotifications()"
              />
            </a>
            -->
          </div>
        </div>
        <table class="left-right-padding">
          <thead>
            <tr>
              <th class="rule left-padding no-margin">
                Job Type
              </th>
              <th class="rule">
                Job Trigger Type
              </th>
              <th class="rule">
                Send To
              </th>
              <th class="rule">
                Frequency Type
              </th>
              <th class="rule">
                Severity
              </th>
              <th class="rule last-child">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(schedule, index) in systemSchedules" :key="index">
              <td class="left-padding no-margin">
                <span
                  class="tag source-tag no-margin"
                  style="font-size: 12px"
                >
                  {{ schedule.job.jobType }}
                </span>
              </td>
              <td>
                {{ schedule.job.jobTriggerType }}
              </td>
              <td>
                {{ schedule.notification.sendTo }}
              </td>
              <td>
                {{ schedule.schedule.frequencyType }}
              </td>
              <td>
                {{ schedule.notification.severity }}
              </td>
              <td>
                <a>
                  <span style="font-size: 17px">
                    <font-awesome-icon
                      :icon="['far', 'angle-double-right']"
                      size="lg"
                      title="View Details"
                      role="button"
                      tabindex="0"
                      @keypress="viewSystemNotificationsDetails(schedule)"
                      @click="viewSystemNotificationsDetails(schedule)"
                    />
                  </span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!SysInfoPosted" class="center is-size-4">
          <div class="icon exception-icon">
            <font-awesome-icon :icon="['fal', 'exclamation-triangle']" size="2x"/>
          </div>
          <p class="exception-text" v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
            Click
            <a tabindex="0" role="button"
                @click="addNewSystemNotifications()"
                @keydown.enter.prevent="addNewSystemNotifications()"
            >
              <span>+Add</span>
            </a>
            <span> to create a new notification.</span>
          </p>
        </div>
        <div class="notification-type">
          <div>
            <th>
              <font-awesome-icon :icon="['fas', 'cog']" size="lg"/>
                Near Match Notifications
            </th>
          </div>
          <div class="icon-right">
            <a v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
              <font-awesome-icon
                :icon="['fal', 'plus']"
                size="2x"
                title="Add Near Match Notifications"
                role="button"
                tabindex="0"
                @keypress="addNewNearMatchNotifications()"
                @click="addNewNearMatchNotifications()"
              />
            </a>
          </div>
        </div>
        <table class="left-right-padding">
          <thead>
            <tr>
              <th class="rule left-padding">
                Job Level
              </th>
              <th class="rule">
                Send To
              </th>
              <th class="rule">
                Frequency Type
              </th>
              <th class="rule">
                Frequency Details
              </th>
              <th class="rule">
                Severity
              </th>
              <th class="rule last-child">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(schedule, index) in nearMatchSchedules" :key="index">
              <td class="left-padding no-margin">
                <span
                  class="tag source-tag no-margin"
                  style="font-size: 12px"
                >
                  {{ schedule.job.jobLevel }}
                </span>
              </td>
              <td>
                {{ schedule.notification.sendTo }}
              </td>
              <td>
                {{ schedule.schedule.frequencyType }}
              </td>
              <td>
                {{ formattedTime(schedule.schedule.startTime) }}
              </td>
              <td>
                {{ schedule.notification.severity }}
              </td>
              <td>
                <a>
                  <span style="font-size: 17px">
                    <font-awesome-icon
                      :icon="['far', 'angle-double-right']"
                      size="lg"
                      title="View Near Match Details"
                      role="button"
                      tabindex="0"
                      @keypress="viewNearMatchNotificationsDetails(schedule)"
                      @click="viewNearMatchNotificationsDetails(schedule)"
                    />
                  </span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!NmInfoPosted" class="center is-size-4">
          <div class="icon exception-icon">
            <font-awesome-icon :icon="['fal', 'exclamation-triangle']" size="2x"/>
          </div>
          <p class="exception-text" v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
            Click
            <a tabindex="0" role="button"
                @click="addNewNearMatchNotifications()"
                @keydown.enter.prevent="addNewNearMatchNotifications()"
            >
              <span>+Add</span>
            </a>
            <span> to create a new notification.</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleDoubleRight } from '@fortawesome/pro-regular-svg-icons';
import { faCog } from '@fortawesome/pro-solid-svg-icons';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleDoubleRight,
  faCog,
  faPlus,
);

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
  ],
  created() {
    this.onLoad();
  },
  components: {
    EsException,
    EsHeader,
    EsLoader,
  },
  data() {
    return this.initialData();
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      activeModules: 'appModules/activeModules',
      allModules: 'appModules/getAllModules',
      properties: 'propertiesModule/properties',
    }),
    formattedTime() {
      return (time) => {
        const date = new Date();
        date.setHours(Math.floor(time / 100));
        date.setMinutes(time % 100);
        return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
      };
    },
  },
  methods: {
    addNewSystemNotifications() {
      this.$emit('addSystemNotification');
      this.hideNotification();
    },
    addNewNearMatchNotifications() {
      this.$emit('addNearMatchNotification');
      this.hideNotification();
    },
    viewNearMatchNotificationsDetails(sendSchedule) {
      this.$emit('viewNearMatchNotificationDetails', sendSchedule);
      this.hideNotification();
    },
    viewSystemNotificationsDetails(sendSchedule) {
      this.$emit('viewSystemNotificationDetails', sendSchedule);
      this.hideNotification();
    },
    initialData() {
      return {
        loading: false,
        loadingError: false,

        sysSchedules: [],
        nearMatchSchedules: [],

        SysInfoPosted: false,
        NmInfoPosted: false,
      };
    },
    async onLoad() {
      try {
        this.loading = true;
        this.loadingError = false;

        if ((this.activeModule && this.activeModule.name) === 'personId') {
          const res = await axios.get('schedules/list/pid');
          this.systemSchedules = res.data.filter(schedule => schedule.job.jobType === 'System');
          this.nearMatchSchedules = res.data.filter(schedule => schedule.job.jobType === 'Near Match');
        } else if ((this.activeModule && this.activeModule.name) === 'directMatch') {
          const res = await axios.get('schedules/list/dm');
          this.systemSchedules = res.data.filter(schedule => schedule.job.jobType === 'System');
          this.nearMatchSchedules = res.data.filter(schedule => schedule.job.jobType === 'Near Match');
        } else if ((this.activeModule && this.activeModule.name) === 'locationID') {
          const res = await axios.get('schedules/list/loc');
          this.systemSchedules = res.data.filter(schedule => schedule.job.jobType === 'System');
          this.nearMatchSchedules = res.data.filter(schedule => schedule.job.jobType === 'Near Match');
        } else {
          const res = await axios.get('schedules');
          this.systemSchedules = res.data.filter(schedule => schedule.job.jobType === 'System');
          this.nearMatchSchedules = res.data.filter(schedule => schedule.job.jobType === 'Near Match');
        }
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
        if (this.systemSchedules.length) {
          this.SysInfoPosted = true;
        }
        if (this.nearMatchSchedules.length) {
          this.NmInfoPosted = true;
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  table th
    vertical-align: middle
  table td
    vertical-align: middle
  table tr.disabled
    color: #C4C5C6
    cursor: not-allowed
  a.disabled
    color: #E6E6E6
    cursor: default
    text-decoration: none
    pointer-events: none
    &:hover
      text-decoration: none
  .header
    display: flex
    align-items: center
  .icon-right
    margin-left: auto
    font-size: 12px
  .last-child
    font-size: 12px
    text-align: right
    width: 1%
    white-space: nowrap
    padding-right: 4rem
  .left-padding
    padding-left: 1.5rem
  .left-right-padding
    padding: 0 0.75rem
  .no-border
    border: 0
  .pipeline-border
    border-left: 1px solid #DEE2E6
  .notification-type
    display: flex
    border-bottom: none
    padding: 1rem 0
  .rule
    font-size: 12px
    color: #666
  .top-padding
    padding-top: 2rem
  .center
    padding: 5rem
    align-items: center
    justify-content: center
    flex-direction: column
  .no-margin
    margin-bottom: 0
    vertical-align: middle
  .exception-text
    font-size: 17.5px
  .exception-icon
    pointer-events: none !important
</style>
